import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";

import { ErrorFallback } from "@/components/ErrorFallback";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppRoutes } from "@/routes";

/**
 * Sprint 7 B4: `Sentry.ErrorBoundary` envuelve toda la app.
 * - En producción con DSN configurado, captura errores React no
 *   manejados, los reporta a Sentry y muestra `<ErrorFallback />`.
 * - En dev (sin `initSentry()`) la ErrorBoundary sigue actuando como
 *   un React error boundary normal (sin reportar a Sentry) — el
 *   componente fallback aparece igualmente cuando el árbol revienta.
 */
export function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}
